import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import DashboardLayout from '../layouts/templates/DashboardLayout/DashboardLayout';
import {ROUTES_SUPER_ADMIN, ROUTES_ADMIN, ROUTES_AUTH, ROUTES_CERTIFIER, ROUTES_CERTIFIER_BODY_ADMIN, ROUTES_FACTORY, ROUTES_PUBLIC, ROUTES_STORE, ROUTES_USER, ROUTES_WHOLESALER } from './route_list';
import ProtectedRoute from './protected_route';
import ErrorElement from '../pages/Error/Error_Element/ErrorElement';
const MaintenancePage = lazy(() => import('../pages/MaintenancePage/MaintenancePage'));
const Admindashboard = lazy(() => import('../pages/@Admin/Admin-dashboard/Admindashboard'));
const Admin_Settings = lazy(() => import('../pages/@Admin/Admin_Settings/Admin_Settings'));
const Modify_store = lazy(() => import('../pages/@factory/Modify_store/Modify_store'));
const Login = lazy(() => import('../pages/Login/Login'));


const ROLES_OPTIONS = {
    ADMIN: "Admin",
    SUPER_ADMIN: "Super_Admin",
    FACTORY: "Factory",
    CERTIFIER: "Certifier",
    WHOLESALER: "Wholesaler",
    USER: "user" ,
    STORE: "Store",
    CERTIFIER_BODY_ADMIN: "Certifier_Body_Admin"
};

const withErrorElement = (routes) => {
    return routes.map(route => ({
        ...route,
        errorElement: <ErrorElement />
    }));
}

//Super Admin routes
export const superadminRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.SUPER_ADMIN]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_SUPER_ADMIN),
        },
    ],
};


//Admin routes
export const adminRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.ADMIN]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_ADMIN),
        },
    ],
};

//Factory routes
const factoryRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.FACTORY]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_FACTORY)
        }
    ]
};

//Certifier_Body_Admin routes
const certifierBodyAdminRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.CERTIFIER_BODY_ADMIN]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_CERTIFIER_BODY_ADMIN)
        }
    ]
};

//Certifier routes
export const certifierRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.CERTIFIER]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_CERTIFIER)
        }
    ]
};

// Wholesaler routes
const wholesalerRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.WHOLESALER]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_WHOLESALER)
        }
    ]
};

// User routes
const userRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.USER]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_USER)
        }
    ]
};

// Store routes
const storeRoutes = {
    element: <ProtectedRoute allowedRoles={[ROLES_OPTIONS.STORE]} />,
    children: [
        {
            element: <DashboardLayout />,
            errorElement: <ErrorElement />,
            children: withErrorElement(ROUTES_STORE)
        }
    ]
};

const publicRoutes = withErrorElement(ROUTES_PUBLIC);
const authRoutes = withErrorElement(ROUTES_AUTH)

// Unreferenced 
const unreferencedRoutes = [
    { path: "/Modify_store/:storeId", element: <Modify_store /> },
];

const maintenanceRoutes = [
    { path: "/admin-access", element: <Login isAdminAccess={true} />, errorElement: <ErrorElement /> },
    { path: "/", element: <MaintenancePage />, errorElement: <ErrorElement /> },
    { path: "*", element: <Navigate to="/" /> },
    {
        element: <DashboardLayout />,
        errorElement: <ErrorElement />,
        children: [
            { path: "/Admindashboard", element: <Admindashboard />, errorElement: <ErrorElement /> },
            { path: "/Admin_Settings", element: <Admin_Settings />, errorElement: <ErrorElement /> },
        ]
    }
];

export const maintenanceRouter = createBrowserRouter([
    maintenanceRoutes
]);

// Links role with routes
export const roleBasedRoutes = {
    [ROLES_OPTIONS.ADMIN]: adminRoutes,
    [ROLES_OPTIONS.FACTORY]: factoryRoutes,
    [ROLES_OPTIONS.CERTIFIER_BODY_ADMIN]: certifierBodyAdminRoutes,
    [ROLES_OPTIONS.CERTIFIER]: certifierRoutes,
    [ROLES_OPTIONS.WHOLESALER]: wholesalerRoutes,
    [ROLES_OPTIONS.USER]: userRoutes,
    [ROLES_OPTIONS.STORE]: storeRoutes,
    [ROLES_OPTIONS.SUPER_ADMIN]: superadminRoutes,
    'SuperAdmin': superadminRoutes,
};

// Function to get the router base on the role
export const getRouter = (role) => {
    console.log('Current user role:', role); // AJOUTEZ CETTE LIGNE
    console.log('Available routes for this role:', roleBasedRoutes[role]); // ET CETTE LIGNE
    const roleRoute = roleBasedRoutes[role] ?? null;

    return createBrowserRouter([
        ...(roleRoute ? [roleRoute] : []),
        ...publicRoutes,
        ...authRoutes,
        ...unreferencedRoutes,
    ]);
};